module.exports = __webpack_public_path__ + "static/media/passport.49658184.svg";